import { debounce } from '@submize/lodash';
import { useEffect, useMemo, useRef } from 'react';

const useDebounce = (callback) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = (a2) => {
      ref.current?.(a2);
    };

    return debounce(func, 250);
  }, []);

  return debouncedCallback;
};
export default useDebounce;
